import { useUser } from "@/hooks/use-user";
import { useLocation } from "wouter";
import { useEffect, useState } from "react";
import Layout from "@/components/layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import useSWR from "swr";
import { supabase } from "../../supabaseClient"; 
import { Users, FolderKanban, UserCheck, Building, User2Icon } from "lucide-react";

export default function Dashboard() {
  const { user, isLoading } = useUser();
  const [, setLocation] = useLocation();
 


  const [agenciesCount, setAgenciesCount] = useState(0); 
  const [hrCount, setHrCount] = useState(0);
  const [VendorCount, setVendorCount] = useState(0);
  const [CandidateCount, setCandidateCount] = useState(0);
  const [roleCount, setRoleCount] = useState(0);



  useEffect(() => {
    const fetchAgencies = async () => {
      const { data, error } = await supabase.from("agency").select("id");
      if (!error && data) {
        setAgenciesCount(data.length); 
      } else {
        console.error("Error fetching agencies:", error);
      }
    };
    const fetchHr = async () => {
      const { data, error } = await supabase.from("hr").select("id");
      if (!error && data) {
        setHrCount(data.length); 
      } else {
        console.error("Error fetching Hr:", error);
      }
    };
    const fetchVendor = async () => {
      const { data, error } = await supabase.from("vendors").select("id");
      if (!error && data) {
        setVendorCount(data.length); 
      } else {
        console.error("Error fetching Vendor:", error);
      }
    }; const fetchCandidate = async () => {
      const { data, error } = await supabase.from("candidates").select("id");
      if (!error && data) {
        setCandidateCount(data.length); 
      } else {
        console.error("Error fetching Candidate:", error);
      }
    }; const fetchRole = async () => {
      const { data, error } = await supabase.from("projects").select("id");
      if (!error && data) {
        setRoleCount(data.length); 
      } else {
        console.error("Error fetching role:", error);
      }
    };
    fetchHr();
    fetchAgencies();
    fetchVendor();
    fetchCandidate();
    fetchRole();
  }, []);

  useEffect(() => {
    if (!isLoading && !user) {
      setLocation("/login");
    }
  }, [user, isLoading, setLocation]); 

  if (isLoading) return <div>Loading...</div>; 
  if (!user) return null;

  const stats = [
    {
      name: "Total Vendors",
      value: VendorCount,
      icon: Users,
      color: "text-blue-600",
      route: "/vendors", // Add route for navigation
    },
    {
      name: "Total Roles",
      value: roleCount,
      icon: FolderKanban,
      color: "text-green-600",
      route: "/roles", // Add route for navigation
    },
    {
      name: "Total Candidates",
      value: CandidateCount,
      icon: UserCheck,
      color: "text-purple-600",
      route: "/candidates", // Add route for navigation
    },
    {
      name: "Total Agencies",
      value: agenciesCount, 
      icon: Building,
      color: "text-orange-600",
      route: "/agencies", // Add route for navigation
    },
    {
      name: "Total HRs",
      value: hrCount,
      icon: User2Icon,
      color: "text-blue-600",
      route: "/hr", // Add route for navigation
    },
  ];

  return (
    <Layout>
      <div className="space-y-8">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Dashboard</h2>
          <p className="text-muted-foreground">Welcome back, {user.username}</p>
        </div>

        <div className="grid gap-4 md:grid-cols-4">
          {stats.map((stat) => (
            <div
              key={stat.name}
              onClick={() => setLocation(stat.route)}
              className="cursor-pointer"
            >
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    {stat.name}
                  </CardTitle>
                  <stat.icon className={`h-4 w-4 ${stat.color}`} />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">{stat.value}</div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        {/* Recent Activity */}
        <Card>
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              No recent activity to show.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
